import MessageSelector from './MessageSelector';

export default MessageSelector;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSelector/index.js